<div class="container-fluid">
    <div class="row">
        <div class="col-md-3" >
            <a routerLink="/naac/ssr/criteria1/1-3"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>1.3.2</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li class="first">
                        <a (click)="changeRoute('1')">2021-2022</a>
                    </li>
                    
                </ul>
            </nav>
        </div>
        <div class="col-md-9">
            <div class="container-fluid" *ngIf="!showBrief">
                <div class="row">
                    <div class="col-12">
                        <div class="card shadow-lg">
                            <h4 class="card-title text-center">Projects Work/Field Work</h4>
                            <div class="card-body text-justify">
                                <table class="table table-bordered table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">S.NO.</th>
                                        <th scope="col">TITLE</th>
                                        <th scope="col">URL</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr *ngFor="let item of session; let i = index;">
                                        <th scope="row">{{i+1}}</th>
                                        <td class="title">{{item.title}}</td>
                                        <td class="link"><a href="{{item.link}}" target="_blank"><i class="fas fa-eye"></i></a> </td>
                                      </tr>
                                     
                                    </tbody>
                                  </table>
                            </div>
                        </div>
          
                    </div>
                </div>
          
               
            </div>
    </div>
</div>